import RouteCategoryNote from "common/RouteCategoryNote";
import RouteListRenderer from "common/RouteListRenderer";

const PAGE_NAME = "General Private Buses (Other Districts)";

const GeneralPrivateBusesOtherDistricts = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Here we list the bus services which are visible in other districts.
          Currently we have listed buses registered in RTAs of Hoogly and Nadia.
          Some are general services with decent frequencies, while others may be
          have fixed times. Some buses are super and have limited stops. They
          not have any defined color schemes.
        </p>

        <p className="my-4">
          Currently routes have been listed listed without distinctions. But
          other features like timings will be added soon.
        </p>

        <RouteCategoryNote pageName={PAGE_NAME} />
      </RouteListRenderer>
    </main>
  );
};

export default GeneralPrivateBusesOtherDistricts;
